<ng-select (change)="onChange($event)"
           [(ngModel)]="schoolProgramValue"
           [disabled]="isDisabled"
           [items]="schoolProgramData"
           [loading]="loading"
           bindLabel="school_program_name"
           [placeholder]= "schoolProgramValue ? '' : ('SELECT' | translate) + ' ' + ('SCHOOL_PROGRAM' | translate)"
           class="selector-style">
  <ng-template ng-option-tmp let-item="item">
    <div class="custom-option-style"  title="{{item.school_program_name}}">{{item.school_program_name}}</div>
  </ng-template>
</ng-select>
